import { Factory } from 'rosie';

Factory.define('DeclinedReassignedSessionNotification');
